import { Link } from 'react-router-dom';
import { categories, articles, brandInfo } from '@/mocks/data';
import ArticleCard from '@/components/base/ArticleCard';

export default function HeroSection() {
  const featuredArticles = articles.filter((a) => a.featured);
  const statsData = [
    { label: '短视频内容', value: brandInfo.videoCount, icon: 'ri-film-line' },
    { label: '活跃用户', value: brandInfo.usersCount, icon: 'ri-user-heart-line' },
    { label: '合作果园', value: brandInfo.partnersCount, icon: 'ri-store-2-line' },
  ];

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[680px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20peach%20orchard%20in%20full%20bloom%20during%20golden%20hour%2C%20pink%20peach%20blossoms%20covering%20rolling%20hills%2C%20warm%20sunset%20light%2C%20cinematic%20landscape%20photography%2C%20soft%20dreamy%20atmosphere%2C%20artistic%20natural%20beauty&width=1800&height=900&seq=hero-peach-orchard&orientation=landscape"
        alt="水蜜桃果园全景"
        title="水蜜桃视频 - 甜蜜果香记录每一刻"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-background-50/15 backdrop-blur-sm rounded-full mb-6">
            <i className="ri-play-circle-fill text-primary-400 text-lg"></i>
            <span className="text-background-50/90 text-sm font-medium">甜蜜果香记录每一刻</span>
          </div>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-6 leading-tight">
            探索水蜜桃的
            <span className="text-primary-400">甜蜜世界</span>
          </h1>
          <p className="text-background-50/80 text-base md:text-lg leading-relaxed mb-8 max-w-xl mx-auto">
            从花开到成熟，从果园到餐桌。水蜜桃视频带你深入果园现场，感受水蜜桃种植、采摘、品鉴与美食制作的全过程。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/plantation"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              探索视频内容
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 border border-background-50/40 text-background-50 rounded-full font-medium text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解我们
            </Link>
          </div>

          <div className="mt-14 grid grid-cols-3 gap-4 md:gap-8">
            {statsData.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="w-10 h-10 md:w-12 md:h-12 mx-auto mb-3 rounded-full bg-background-50/15 flex items-center justify-center">
                  <i className={`${stat.icon} text-primary-400 text-lg md:text-xl`}></i>
                </div>
                <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">{stat.value}</div>
                <div className="text-background-50/60 text-xs md:text-sm mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}